import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

import Layout from "./components/shared/Layout";

const Home = lazy(() => import("./pages/Home"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const Repairments = lazy(() => import("./pages/Repairments/Repairments"));
const Lease = lazy(() => import("./pages/Lease/Lease"));
const Performance = lazy(() => import("./pages/Performance/Performance"));

const LoadingFallback = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="50vh"
  >
    <CircularProgress size={40} />
  </Box>
);

const App = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reparaties" element={<Repairments />} />
            <Route path="/inspiratieles" element={<Lease />} />
            <Route path="/sessies" element={<Performance />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
};

export default App;
